import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { actionButton } from './tokens';

// Mesmo acabamento das ações do grid, com dimensão de botão de formulário.
const ActionButton = styled(Button).attrs({ className: "ui-action-custom" })`
  ${actionButton}
  && {
    min-height: 40px;
    padding: 9px 14px;
    font-size: 13px;
    line-height: 1.4;
    white-space: normal;
    text-align: center;
  }
`;
export default ActionButton;
